<template>
    <div class="white window high-gas-price-info" v-if="showHighGasWarning">
        The Ethereum blockchain is currently experiencing high usage, making it unusually expensive to use. Consider waiting to use Curve.
    </div>
</template>

<script>
    import config from '@/constants/config';
    import { getGasPrice } from '@/utils/GasPrice';

	export default {
		data: () => ({
            gasInfo: undefined,
		}),

		computed: {
            showHighGasWarning() {
                if (config.blockchainId === 'ethereum') {
                    this.fetchGasPrice();
                    if (this.gasInfo && (this.gasInfo.base / 1e9 > 200)) return true;
                    else return false;
                }

                return false;
            },
        },

        methods: {
            async fetchGasPrice() {
              const { data: { eip1559Gas: gasInfo} } = await getGasPrice();
              this.gasInfo = gasInfo;
            },
        },
	}
</script>

<style scoped>
    .high-gas-price-info {
        font-style: italic;
    }
</style>
